import { http } from "./http";
import * as yup from "yup";

export function uploadImage(file) {
    const formData = new FormData();
    formData.append("file", file);

    return http.post(
        `v1/uploads/image`,
        formData,
        {
            headers: { "Content-Type": "multipart/form-data" }
        }
    );
}

export const uploadSchema = yup.object().shape({
    id: yup.string().required(),
    originalName: yup.string().required(),
    fileName: yup.string().required(),
    link: yup.string().required(),
})
